/**
 * 홈페이지 데스크톱 탭 게시판 컴포넌트
 * 공지사항과 언론보도를 탭으로 전환하여 표시합니다.
 */

import { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Preview from '../Preview';
import { getDatas, getNotices } from '../../Api';

// 이미지 import
import moreImg from '../../assets/more.png';

/**
 * DesktopTabBoard 컴포넌트
 * 데스크톱에서 공지사항/언론보도 탭을 전환하는 게시판
 */
function DesktopTabBoard() {
  /**
   * 탭 상태 관리
   * true: 공지사항 탭 활성화
   * false: 언론보도 탭 활성화
   */
  const [isOne, setIsOne] = useState(true);

  /**
   * 탭 전환 핸들러
   * @param {number} chose - 선택된 탭 (1: 언론보도, 그 외: 공지사항)
   */
  const handleBoard = (chose) => {
    if (chose === 1) {
      setIsOne(false);
    } else {
      setIsOne(true);
    }
  };

  return (
    <TabBox>
      <HiddenText as="h3">공지사항</HiddenText>
      <TabList className={isOne ? 'm1' : 'm2'}>
        <ul>
          <TabItem className="m1">
            <TabLink
              to="#"
              onClick={(e) => {
                e.preventDefault();
                handleBoard(0);
              }}
            >
              <span>공지사항</span>
            </TabLink>
            {isOne && (
              <TabMoreLink to="/notice">
                <img src={moreImg} width="20px" alt="공지사항 더보기" />
              </TabMoreLink>
            )}
            <Preview
              address="/notice"
              getdata={getNotices}
              isPhoto={false}
            />
          </TabItem>

          <TabItem className="m2">
            <TabLink
              to="#"
              onClick={(e) => {
                e.preventDefault();
                handleBoard(1);
              }}
            >
              <span>언론보도</span>
            </TabLink>
            {!isOne && (
              <TabMoreLink to="/data">
                <img src={moreImg} width="20px" alt="언론보도 더보기" />
              </TabMoreLink>
            )}
            <Preview
              address="/data"
              getdata={getDatas}
              isPhoto={false}
            />
          </TabItem>
        </ul>
      </TabList>
    </TabBox>
  );
}

export default DesktopTabBoard;

/* Styled Components */

const HiddenText = styled.p`
  position: absolute;
  overflow: hidden;
  top: 0;
  visibility: hidden;
  width: 1px;
  height: 1px;
`;

const TabBox = styled.div`
  /* 데스크톱 기본 스타일 */
  position: relative;
  flex: 1;
  height: 252px;
  border: 1px solid #d7d7d7;
  overflow: hidden;

  /* 모바일 스타일 */
  @media (max-width: 1023px) {
    width: 100%;
    height: auto;
    border: none;
    overflow: visible;
  }
`;

const TabList = styled.div`
  /* 데스크톱 기본 스타일 */
  height: 303px;

  > ul {
    height: 48px;
    background-color: #f4f4f4;
    position: relative;
    margin: 0;
    padding: 0;
    border-bottom: 1px solid #d7d7d7;
    list-style: none;
    overflow: visible;
    display: flex;
  }

  /* 활성 탭 스타일 */
  &.m1 .m1 > a,
  &.m2 .m2 > a {
    margin-top: -1px;

    span {
      color: #1b1b1b;
      background-color: #fff;
    }
  }

  &.m1 .m1 > ul,
  &.m2 .m2 > ul {
    display: block !important;
  }

  /* 모바일 스타일 */
  @media (max-width: 1023px) {
    height: auto;
    width: 100%;
    border-top: 1px solid #f0f0f0;

    > ul {
      height: auto;
      background-color: #fff;
      border-bottom: none;
      flex-direction: column;
    }
  }
`;

const TabItem = styled.li`
  /* 데스크톱 기본 스타일 */

  margin-bottom: -1px;

  > a span {
    display: inline-flex;
    align-items: center;
    padding: 0px 30px;
    height: 48px;
    cursor: pointer;
    font-weight: 600;
    color: #616161;
    font-family: 'Nanum Gothic Bold';
    font-size: 17px;
  }

  > ul {
    display: none;
    position: absolute;
    top: 70px;
    left: 23px;
    width: 460px;
    height: auto;
    margin: 0 !important;
    padding: 0 !important;
    border: 0 !important;
    list-style: none;
    background-color: #fff !important;

    &::after {
      display: block;
      clear: both;
      content: '';
    }

    li {
      position: relative;
      margin: 0 0 15px 15px;
      list-style: disc !important;
      padding-left: 15px !important;
    }
  }

  /* 모바일 스타일 */
  @media (max-width: 1023px) {
    width: 100%;
    border-bottom: 1px solid #e0e0e0;

    &:last-child {
      border-bottom: none;
    }

    > a span {
      padding: 15px 5%;
      font-size: 16px;
      display: block;
    }

    > ul {
      position: static;
      width: 100%;
      left: 0;
      padding: 10px 0 !important;

      li {
        margin: 0 0 10px 5% !important;
        list-style: none !important;
        padding-left: 0 !important;
      }
    }
  }

  @media (min-width: 768px) and (max-width: 1023px) {
    > a span {
      font-size: 20px;
      padding: 20px 5%;
    }
  }
`;

const TabLink = styled(Link)`
  /* 데스크톱 기본 스타일 */
  display: block;
  position: relative;
  border-right: 1px solid #d7d7d7;
  background: #f4f4f4;
  color: #666;
  text-decoration: none;

  /* 모바일 스타일 */
  @media (max-width: 1023px) {
    width: 100%;
    border-right: none;
    background: #fff;
  }
`;

const TabMoreLink = styled(Link)`
  position: absolute;
  right: 10px;
  top: 15px;
  width: 30px;
  height: 30px;
  display: block;
  z-index: 10;
`;
